// extracted by mini-css-extract-plugin
export default {"right":"right--zc5Bs","uploadWrapper":"uploadWrapper--NVVRf","mobile":"mobile--Weca3"};